document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tc").forEach((section) => {
    const tabsWrap = section.querySelector(".tc__tabs");
    const tabs = section.querySelectorAll(".tc__tab");
    const panels = section.querySelectorAll(".tc__panel");

    if (!tabsWrap || !tabs.length || !panels.length) return;

    /* Create underline */
    let underline = tabsWrap.querySelector(".tc__underline");
    if (!underline) {
      underline = document.createElement("div");
      underline.className = "tc__underline";
      tabsWrap.appendChild(underline);
    }

    const moveUnderline = () => {
      const activeTab = tabsWrap.querySelector(".tc__tab.is-active");
      if (!activeTab) return;

      const wrapRect = tabsWrap.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();

      underline.style.width = `${tabRect.width}px`;
      underline.style.transform = `translateX(${tabRect.left - wrapRect.left}px)`;
    };

    const activateTab = (id) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.tcTab === id;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.tcPanel === id;
        if (isActive) {
          panel.hidden = false;
          requestAnimationFrame(() => {
            panel.classList.add("is-active");
          });
        } else {
          panel.classList.remove("is-active");
          panel.hidden = true;
        }
      });

      requestAnimationFrame(moveUnderline);
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        activateTab(tab.dataset.tcTab);
      });
    });

    /* Init on load */
    requestAnimationFrame(() => {
      const firstPanel = panels[0];
      firstPanel.hidden = false;
      firstPanel.classList.add("is-active");
      moveUnderline();
    });

    window.addEventListener("resize", moveUnderline);
  });
});
